import { render, staticRenderFns } from "./AddFileModal.vue?vue&type=template&id=344a4510"
import script from "./AddFileModal.vue?vue&type=script&lang=js"
export * from "./AddFileModal.vue?vue&type=script&lang=js"
import style0 from "./AddFileModal.vue?vue&type=style&index=0&id=344a4510&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports